// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2fcmX","range":"MonthRangeSwitch_range__aqrza","disabled":"MonthRangeSwitch_disabled__2xd3-"};